//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'HendersonHasselbalch',
  data() {
    return {
      defaultJson:{
        "PaCO₂": "PaCO₂",
        "pH": "pH",
        "HCO₃": "HCO₃"
      },
      method:0,
      form:{
        pco2:'',
        ph:'',
        hco3:'',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:0,name:'HCO₃'},
        {value:1,name:'PaCO₂'},
        {value:2,name:'pH'},
      ],
      res:'...',
      activeIndex:0,
      
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(item, index) {
      this.method = item.value;
      this.activeIndex = index
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let method = self.method
      if (method==0) {
        form.hco3 = '0'
      }
      if (method==1) {
        form.pco2 = '0'
      }
      if (method==2) {
        form.ph = '0'
      }
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = 0 
        if (method == 0) {
          // (10^(ph-6.1))*.031*pco2
          result =(Math.pow(10,(form.ph-6.1))) *.031*form.pco2
        } else if (method == 1){
          // hco3/(.031*(10^(ph-6.1)))
          result = form.hco3/ (.031*(Math.pow(10,(form.ph-6.1))))
        }else if (method == 2){
          // 6.1+log((hco3/(.031*pco2)))
          result = 6.1+Math.log10((form.hco3/(.031*form.pco2)))
        }
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/HendersonHasselbalch.vue